import { JwtCustonService } from './../core/auth/jwtCustomService';
import { CallbackService } from './callback.service';
import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { RxjObservableService } from '../services/rxjObservable.service';
import { SessionBusiness } from '../core/_config/sessionBusiness.service';

@Component({
    selector: 'callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
    constructor(
        public rxjs: RxjObservableService,
        private oauthService: OAuthService,
        private callBackService: CallbackService,
        private jwtCustonService: JwtCustonService,
        private session: SessionBusiness,
    ) {}

    tryOauthLogin: any;

    async ngOnInit() {
        this.tryOauthLogin = await this.oauthService.tryLoginImplicitFlow();
        let hasSession = !(this.session.EntityIdContext == 'NotFound');
        if (hasSession) {
            if (this.tryOauthLogin) {
                await this.callBackService.accountsLogin().then(() => {
                    this.rxjs_callLoadGetEntityPermission();
                });
            } else {
                if (this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken()) {
                    await this.callBackService.accountsLogin().then(() => {
                        this.rxjs_callLoadGetEntityPermission();
                    });
                } else {
                    this.oauthService.logOut(false);
                    this.jwtCustonService.logout();
                }
            }
        } else {
            // No valid session context, force login page and avoid callback loop
            //deybson verificar , voltar para tela de login
            // this.oauthService.initImplicitFlow('', { prompt: 'login' });
        }
    }

    rxjs_callLoadGetEntityPermission() {
        this.rxjs.publishSomeData({ value: 'GetEntityPermission' });
    }
}
